export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/subcategories/state.js